import { getProductDetail } from 'api/mall';
import { searchEva } from 'api/order';
import { saveProductSkuInfo } from 'api/product';
import AccountPeriodPicker from 'comps/AccountPeriodPicker';
import AreaPickerWithLevel from './components/AreaPickerWithLevel';
import Button from 'comps/Button';
import Layout from 'comps/Layout';
import MinNav from 'comps/MinNav';
import NoData from 'comps/Nodata';
import ProductDetailAddToCartBar from 'comps/ProductDetailAddToCartBar';
import ProductDetailAddToSkuList from '@/views/h5/product/Detail/components/ProductDetailAddToSkuList';
import ProductDetailAttachment from 'comps/ProductDetailAttachment';
import ProductDetailBasic from '@/views/h5/product/Detail/components/ProductDetailBasic';
import ProductDetailMatImg from 'comps/ProductDetailMatImg';
import ProductDetailMmuPopup, { SkuCategoryAttributeDTO } from './components/ProductDetailMmuPopup';
import ProductDetailRecommend from 'comps/ProductDetailRecommend';
import ProductDetailShopSection from 'comps/ProductDetailShopSection';
import { SimpleNavbar } from 'comps/SimpleNavbar';
import { useAddAnimation } from 'hooks/useAddAnimation';
import useLocalPayment from 'hooks/useLocalPayment';
import useRateAndSellCount from 'hooks/useRateAndSellCount';
import ArrowIcon from 'icons/arrow.svg';
import { ORDER_SOURCE, ProductBuyStatus } from 'libs/cons';
import { CartContext, LocContext, OrderContext, SiteContext, UserContext } from 'libs/contexts';
import { AgreementPriceMissingReason, NetPriceSourceEnum, SITE_MODE, UserSource } from 'libs/enums';
import { PageMallSkuDetail, ProductBuyStatusEnum } from 'libs/types';
import { buildPeriodList } from 'libs/utils';
import { PriceContext } from 'libs/contexts';
import router, { useRouter } from 'next/router';
import { updateObject } from 'rambdax';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Dialog, Toast } from 'react-vant';
import 'react-vant/lib/index.css';
import { cls } from 'reactutils';

// 商城企业版不可售卖提示语更新 20231120 @李翔
export const ProductCantBuyTips = {
  Normal: 'canBuy',
  NotInArea: '该区域不可售',
  NoAgreement: '该商品不可售',
  NoBasePrice: '该商品价格异常',
  SupplierLimitEnable: '供应商被限制交易',
} as const;

type BuyType = 'BuyNow' | 'AddToCart';
type PageStatusProp = null | 'loading' | 'empty';

const NavbarVisibleLimit = 150;
// const defaultAreaCode = "11151212116110918751"

const source = ORDER_SOURCE.SKU;

function canBuyProduct(status: ProductBuyStatusEnum) {
  return status === 'Normal';
}

// 新的商品详情页可售卖规则 TODO 20231121 @李翔
function getCantBuyStatus(
  skuDetail: PageMallSkuDetail,
  skuForPriceCalculate,
): keyof typeof ProductCantBuyTips {
  // 暂无有效的交易规则，无法购买
  if (!skuDetail?.tradeAgreementEntityList?.length) return 'NoAgreement';
  // 地区不可售
  if (!skuDetail.areaCanSale) return 'NotInArea';
  //   获取不到协议价
  if (
    skuDetail.salesPrice === null &&
    skuDetail.agreementCanSale &&
    skuForPriceCalculate?.agreementPriceMissingReason ===
      AgreementPriceMissingReason.TRADE_AGREEMENT_PRICE_MISSING
  ) {
    return 'NoBasePrice';
  }
  //   供应商被限制交易
  if (skuDetail.supplierLimitEnable) return 'SupplierLimitEnable';
  return 'Normal';
}
type PageVisible =
  | 'BuyPopup'
  | 'AreaPicker'
  | 'Share'
  | 'CustomerService'
  | 'NoPayWay'
  | 'NotExceedMinimum';

type PageVisibleObj = {
  [K in PageVisible]: boolean;
};

export default function ProductDetailPage() {
  return (
    <Layout
      header={null}
      footer={null}
      keywords="数字化,供应链管理,数字采购,供应链金融"
      description="通过数字化供应链管理、数字采购、供应链金融等产品和服务，实现产业链上下游协作，进而降本增效"
      title="商品详情"
    >
      <ProductDetail />
    </Layout>
  );
}

export function ProductDetail() {
  const route = useRouter();
  const [returnUrl, setReturnUrl] = useState('');
  // const id = "677155875429127148"
  const id = route.query.id as string;
  const { location } = useContext(LocContext);
  const userInfo = useContext(UserContext);
  const site = useContext(SiteContext);
  const { addCart, refetchCart } = useContext(CartContext);
  const { setOrder } = useContext(OrderContext);
  const { canView } = useRateAndSellCount();
  const [skuDetail, setSkuDetail] = useState<PageMallSkuDetail>({});
  const [choosen, setChoosen] = useState<any>([]);
  const [shopInfo, setShopInfo] = useState<Record<string, string>>({});
  const [, setOrganizationConfig] = useState({
    organizationAccountPeriodList: [],
    organizationSysNo: '',
  });
  const pageRef = useRef<HTMLDivElement>(null);
  const rateRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const recommendRef = useRef<HTMLDivElement>(null);
  const [activeNavTab, setActiveNavTab] = useState<'top' | 'rate' | 'content' | 'recommend'>('top');
  const playTargetRef = useRef<any>(null);
  const playSrcRef = useRef<any>(null);
  const playStar = useAddAnimation(playSrcRef, playTargetRef);
  const [selectTradeAgreement, setSelectTradeAgreement] = useState<TradeAgreementInfo>(null);
  const [selectNetPriceType, setSelectNetPriceType] = useState(null);
  const [selectAccountPeriod, setSelectAccountPeriod] = useState<DiscountByMethodInfo>(null);
  const [taxRate, setTaxRate] = useState(0);
  const [selectAreas, setSelectAreas] = useState<Array<AreaItem>>([]);
  const [pageStatus, setPageStatus] = useState<PageStatusProp>('loading');
  const [navOpacity, setNavOpacity] = useState(0);
  const NavbarHeight = 44;
  const [tradeAgreementEntityList, setTradeAgreementEntityList] = useState<TradeAgreementInfo[]>(
    [],
  );
  const [rateTotal, setRateTotal] = useState(0);

  const mmuPopupRef = useRef(null);

  const [visibles, setVisibles] = useState<PageVisibleObj>({
    BuyPopup: false,
    AreaPicker: false,
    Share: false,
    CustomerService: false,
    NoPayWay: false,
    NotExceedMinimum: false,
  });
  const [buyType, setBuyType] = useState<BuyType>('AddToCart');

  const { updateLocalPayment, updateLocalTradeAgreement, getPaymentLocalObj } = useLocalPayment();

  const firstLoad = useRef(true);

  const [station, setStation] = useState<Array<Station>>([]);
  const [selectStation, setSelectStation] = useState<Station>(null);
  const [skuList, setSkuList] = useState<Array<MmuMallSku>>([]);
  const [showUsePart, setShowUsePart] = useState(false);
  const [mmuAttributeList, setMmuAttributeList] = useState<SkuCategoryAttributeDTO[]>([]);
  const [mmuAttributeClassifiers, setMmuAttributeClassifiers] = useState<string[]>([]);
  const isChangeTradeAgreement = useRef(false);
  // const detailContentOfHtml = DOMPurify?.sanitize?.(skuDetail.detailContentOfHtml, {
  //   ADD_TAGS: ['link'],
  // });

  const priceData = useContext(PriceContext);
  const { showPrice, tip } = priceData;

  const isOutSide = userInfo?.organizationSource === UserSource.outside; //是否为外部采购商
  function getFrontDefaultTradeMethodList() {
    const paymentSysNoObj = getPaymentLocalObj();
    const frontDefaultTradeMethodList = [];
    paymentSysNoObj.forEach((item) => {
      if (item.sysNo) {
        const period = item.sysNo?.split('-');
        frontDefaultTradeMethodList.push({
          supplierSysNo: item.supplierSysNo,
          agreementSysNo: item.tradeAgreementSysNo,
          accountPeriod: period?.[0] ?? null,
          billingPeriod: period?.[1] ?? null,
        });
      }
    });
    return frontDefaultTradeMethodList;
  }

  function updatePaymentLocalObj(list, netPriceType) {
    const activeTradeAgreement: TradeAgreementInfo = list?.find((i) => i.active);
    if (activeTradeAgreement) {
      const { supplierSysNo } = skuDetail;
      updateLocalTradeAgreement(activeTradeAgreement.sysNo, supplierSysNo);
      const discountByMethodList = buildPeriodList(
        activeTradeAgreement.discountByMethodList || [],
        supplierSysNo,
        activeTradeAgreement.billingPeriodOtherDays,
      );

      if (activeTradeAgreement.netPriceTypeList?.length > 1) {
        setSelectNetPriceType(netPriceType || NetPriceSourceEnum.LANGE);
      } else {
        setSelectNetPriceType(null);
      }

      // if (!hasNotChangeTradeAgreement(activeTradeAgreement)) {
      setSelectTradeAgreement(activeTradeAgreement);
      // }

      if (discountByMethodList.length) {
        const activeDiscount = discountByMethodList.find((i) => i.active);
        if (activeDiscount) {
          updateLocalPayment(activeDiscount.sysNo, supplierSysNo);
          if (selectAccountPeriod?.sysNo !== activeDiscount.sysNo) {
            setSelectAccountPeriod(activeDiscount);
          }
        }
      }
    } else {
      setSelectNetPriceType(null);
      setSelectTradeAgreement(null);
    }
  }

  const handleLogin = useCallback(() => {
    router.push(`/login?return_url=${encodeURIComponent(window.location.href)}`);
  }, []);

  async function getDetail(
    sysNo: string,
    _condition: any = {},
    _updatesetTradeAgreementEntityList: boolean = true,
  ) {
    const { areaCode } = location;
    if (!areaCode) return;
    const json = {
      frontDefaultTradeMethodList: getFrontDefaultTradeMethodList(),
      sysNo,
      areaCode,
      chooseAgreement: selectTradeAgreement?.sysNo
        ? {
            supplierSysNo: skuDetail.supplierSysNo,
            agreementSysNo: selectTradeAgreement?.sysNo,
            accountPeriod: selectAccountPeriod?.accountPeriod,
            billingPeriod: selectAccountPeriod?.billingPeriod,
          }
        : null,
      netPriceType: selectNetPriceType,
      ..._condition,
    };
    try {
      const res = (await getProductDetail(json)) as APIJSON<{
        mallSku: PageMallSkuDetail;
        shop: {
          name: string;
        };
        organizationConfig?: {
          organizationAccountPeriodList: any[];
          organizationSysNo: string;
        };
      }>;
      if (res && res.data) {
        setShopInfo(res.data.shop || {});
        setOrganizationConfig(res.data.organizationConfig);
        const data = res.data.mallSku;
        try {
          updatePaymentLocalObj(data.tradeAgreementEntityList, data.netPriceType);
        } catch (err) {}
        const prevId = skuDetail.sysNo;
        setSkuDetail(data);
        setTaxRate(data.taxRate);
        setPageStatus(null);
        const choosenList =
          data.attributeList &&
          data.attributeList.reduce((p, c, index) => {
            const active = c.categoryAttributeValueList.findIndex((x) => x.active);
            p[index] = active && active >= 0 ? active : 0;
            return p;
          }, {} as any);
        setChoosen(choosenList);
        if (prevId !== data.sysNo) {
          pageRef.current.scrollTo({
            top: 0,
          });
        }
        if (_updatesetTradeAgreementEntityList) {
          setTradeAgreementEntityList(data.tradeAgreementEntityList);
        }
      } else if (res.code === 404 || !res.data) {
        setPageStatus('empty');
      }
    } catch (err) {}
  }

  function handleChangeSku(sysNo) {
    if (!sysNo) return;
    const path = `/product/detail?id=${sysNo}`;
    router.push(path, path, { shallow: true });
  }

  async function handleChangeAgreementOrAccountPeriod() {
    if (selectAccountPeriod?.sysNo && selectTradeAgreement?.sysNo) {
      /**
       * 首次请求获取数据后会触发交易方式和协议的修改，
       * 因为首次请求的时候已经把本地缓存的交易方式和协议给了服务端，
       * 所以首次交易方式和协议修改不触发请求
       */
      if (!firstLoad.current) {
        if (isChangeTradeAgreement.current) {
          // 如果是手动修改的协议，交易方式可能也会修改。等拿到最新的交易方式后再请求getSkuList
          isChangeTradeAgreement.current = false;
          await getDetail(id, { mmuAttributeList }, false);
          setTimeout(() => {
            mmuPopupRef.current?.getSkuList(false);
          }, 0);
        } else {
          getDetail(id, { mmuAttributeList }, false);
          mmuPopupRef.current?.getSkuList(false);
        }
      } else {
        firstLoad.current = false;
      }
    }
  }

  function handleChangeMmu(list: SkuCategoryAttributeDTO[]) {
    setMmuAttributeList(list);
    // getDetail(id, { list });
  }

  function renderChoosenTxt() {
    return skuDetail.attributeList
      ? skuDetail.attributeList
          .map((attr, idx) => {
            const { attributeValue, active } = attr?.categoryAttributeValueList[choosen[idx]] || {};
            if (active && attributeValue) {
              return attributeValue;
            }
          })
          .filter((item) => item)
          .join('，')
      : '--';
  }

  const choosenTxt = renderChoosenTxt();

  const onScroll = (ev) => {
    const { scrollTop } = ev.currentTarget;
    if (scrollTop > NavbarVisibleLimit) {
      setNavOpacity(1);
    } else {
      setNavOpacity(scrollTop / NavbarVisibleLimit);
    }

    if (scrollTop < rateRef.current!.offsetTop - NavbarHeight) {
      setActiveNavTab('top');
    } else if (scrollTop < contentRef.current!.offsetTop - NavbarHeight) {
      setActiveNavTab('rate');
    } else if (scrollTop < recommendRef.current!.offsetTop - NavbarHeight) {
      setActiveNavTab('content');
    } else {
      setActiveNavTab('recommend');
    }
  };

  const scrollToTop = () => {
    pageRef.current?.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const scrollToRate = () => {
    pageRef.current?.scrollTo({
      top: rateRef.current!.offsetTop - NavbarHeight,
      behavior: 'smooth',
    });
  };

  const scrollToContent = () => {
    pageRef.current?.scrollTo({
      top: contentRef.current!.offsetTop - NavbarHeight,
      behavior: 'smooth',
    });
  };

  const scrollToRecommend = () => {
    pageRef.current?.scrollTo({
      top: recommendRef.current!.offsetTop - NavbarHeight,
      behavior: 'smooth',
    });
  };

  const onPupupSubmit = () => {
    // 未登录
    if (!userInfo) {
      updateVisible('BuyPopup', false);
      handleLogin();
      return;
    }

    // 采购商身份检查
    if (!userInfo.isPurchaser) {
      updateVisible('BuyPopup', false);
      Dialog.alert({
        title: '提示',
        message: `抱歉，您不是采购商，无法购买。您可以前往3jyx.cn认证成为采购商`,
        confirmButtonText: '我知道了',
      });
      return;
    }

    const sku = mmuPopupRef.current.buildSku();

    // 校验不通过
    if (!sku) return;

    if (sku.shopQuantity <= 0) {
      Toast.fail('请输入采购数量！');
      return;
    }

    if (buyType === 'AddToCart') {
      // let OldAddGoodsParams: OldAddCartGoodsProps = {
      //   paymentSysNo: null,
      //   mallSkuSysNo: id,
      //   quantity: sku.shopQuantity,
      //   warehouseSysNo: skuDetail.warehouseSysNo + '',
      //   areaSysNo: location.sysNo as any,
      //   shopQuantity: sku.shopQuantity,
      //   mmuAttributeList: sku.mmuAttributeList,
      // };
      const addGoodsParams: AddCartGoodsProps = {
        paymentSysNo: null,
        mallSkuSysNo: id,
        quantity: sku.shopQuantity,
        warehouseSysNo: skuDetail.warehouseSysNo + '',
        areaSysNo: location.sysNo as any,
        shopQuantity: sku.shopQuantity,
        mmuAttributeList: sku.mmuAttributeList,
        billingPeriod: selectAccountPeriod?.billingPeriod,
        accountPeriod: selectAccountPeriod?.accountPeriod,
        agreementSysNo: selectTradeAgreement?.sysNo,
        netPriceType: selectNetPriceType,
      };

      addCart(
        addGoodsParams,
        async () => {
          updateVisible('BuyPopup', false);
          // 动画结束才更新
          await playStar();
          refetchCart();
        },
        (msg: string) => {
          Toast.fail({
            message: msg,
          });
        },
      );

      return;
    } else {
      const params = {
        areaSysNo: location.sysNo,
        type: 0,
        simulateSplitGroup: [
          {
            supplierSysNo: shopInfo.supplierSysNo,
            shopSysNo: shopInfo.sysNo,
            tradeAgreementSysNo: selectTradeAgreement?.sysNo,
            netPriceType: selectNetPriceType,
            paymentType: selectAccountPeriod?.accountPeriod ?? null,
            billingPeriod: selectAccountPeriod?.billingPeriod ?? null,
            groupSysNo: Math.floor(Math.random() * Math.pow(10, 13) + Date.now()).toString(),
            skuList: [
              {
                sysNo: id,
                mallSkuSysNo: id,
                warehouseSysNo: skuDetail.warehouseSysNo,
                quantity: null,
                shopQuantity: sku.shopQuantity,
                mmuAttributeList: sku.mmuAttributeList,
              },
            ],
            skuType: skuDetail.skuType,
          },
        ],
      } as any;

      setOrder((p) => ({
        ...p,
        skuParams: {
          ...params,
        },
        formData: null,
        receiveAddress: null,
      }));

      router.push('/order/create');
    }
  };

  const updateVisible = (key: PageVisible, val: boolean) => {
    setVisibles((prev) => updateObject([[key, val]], prev));
  };

  const getRateTotal = async () => {
    const json = {
      evaluateObjectType: 2,
      status: 1,
      evaluateObjectSysNo: shopInfo.supplierSysNo,
    };
    searchEva(json).then((res) => {
      if (res.code === 200) {
        setRateTotal(res?.data?.total);
      }
    });
  };

  // NOTE: 初始化获取商品详情

  useEffect(() => {
    getDetail(id, { mmuAttributeList });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, location]);

  useEffect(() => {
    handleChangeAgreementOrAccountPeriod();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectAccountPeriod?.sysNo, selectTradeAgreement?.sysNo]);

  useEffect(() => {
    const { href } = window.location;
    setReturnUrl(encodeURIComponent(href));
    if (canView && shopInfo.supplierSysNo) {
      getRateTotal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopInfo.supplierSysNo]);

  // 价格变化时提交浏览记录
  useEffect(() => {
    const { salesPrice, unitName, name, mainImage, sysNo } = skuDetail;
    if (!sysNo) {
      return;
    }
    const saveHistory = async () => {
      await saveProductSkuInfo({
        supplierSkuSysNo: sysNo,
        productImgUrl: mainImage,
        shopMainPage: shopInfo.sysNo,
        productName: name,
        productPrice: showPrice
          ? salesPrice
            ? `${salesPrice}元/${unitName}`
            : `--元/${unitName}`
          : tip,
      });
    };
    saveHistory();
  }, [skuDetail.salesPrice]);

  const skuForPriceCalculate = (
    selectTradeAgreement?.skuForPriceCalculate?.length
      ? selectTradeAgreement?.skuForPriceCalculate.find((s) => +s.sysNo === +skuDetail.sysNo)
      : null
  ) as any;
  const productStatus = getCantBuyStatus(skuDetail, skuForPriceCalculate);
  const productCantBuyStatus = getCantBuyStatus(skuDetail, skuForPriceCalculate);
  const isBuyable = canBuyProduct(productCantBuyStatus);
  const cantBuyable = !canBuyProduct(productCantBuyStatus);

  if (pageStatus === 'loading') {
    return null;
  }

  if (pageStatus === 'empty') {
    return (
      <div>
        <SimpleNavbar />
        <NoData />
      </div>
    );
  }

  const toShop = () => {
    sessionStorage.removeItem(`/shop/index/${shopInfo.sysNo}`);
    router.push(`/shop/index/${shopInfo.sysNo}`);
  };

  const activeTabClassName = () => cls('navTab', activeNavTab === 'rate' ? 'active' : null);
  return (
    <>
      <main className="page">
        <SimpleNavbar rightComp={<MinNav />}>
          <div className="navTabs" style={{ opacity: navOpacity }}>
            <div onClick={scrollToTop} className={activeTabClassName()}>
              商品
            </div>
            <div onClick={scrollToRate} className={activeTabClassName()}>
              评价
            </div>
            <div onClick={scrollToContent} className={activeTabClassName()}>
              详情
            </div>
            <div onClick={scrollToRecommend} className={activeTabClassName()}>
              推荐
            </div>
          </div>
        </SimpleNavbar>
        {skuDetail.supplierLimitEnable && (
          <div className="tip-wrap">
            该供应商已被限制平台交易，您可以继续浏览店铺或商品，但不能向供应商下单。
          </div>
        )}
        <div className="pageContent">
          <div
            className="main"
            style={{ flexBasis: `calc(100vh - ${NavbarHeight + 56}px)` }}
            ref={pageRef}
            onScroll={onScroll}
          >
            <ProductDetailMatImg
              mainImage={skuDetail.mainImage}
              imgPaths={skuDetail.imgPaths}
              imgTag={skuDetail.imageProductTag}
              ref={playSrcRef}
            />
            <ProductDetailBasic
              {...skuDetail}
              taxRate={taxRate}
              supplierSysNo={shopInfo.supplierSysNo}
              tradeAgreementEntityList={tradeAgreementEntityList}
              isNotInArea={productStatus === 'NotInArea'}
              priceWithoutTax={skuDetail.excludeTaxPrice}
              skuDetail={skuDetail as any}
              tradeAgreementSysNo={selectTradeAgreement?.sysNo}
              skuForPriceCalculate={skuForPriceCalculate}
              choosen={choosenTxt}
              productStatus={productStatus}
              selectTradeAgreement={selectTradeAgreement}
              selectNetPriceType={selectNetPriceType}
              onSelectAgreement={(data: TradeAgreementInfo) => {
                if (data.sysNo !== selectTradeAgreement.sysNo) {
                  // 规则变化；或规则和netprice一起变
                  isChangeTradeAgreement.current = true;
                  setSelectTradeAgreement(data);
                  setSelectNetPriceType(data.netPriceType);
                  setTaxRate(data.skuForPriceCalculate?.[0].taxRate);
                  return;
                } else if (data.netPriceType) {
                  // netPrice变化
                  setSelectNetPriceType(data.netPriceType);
                  getDetail(id, { mmuAttributeList, netPriceType: data.netPriceType }, false);
                }
              }}
              onUpdateProduct={() => {
                getDetail(id, { mmuAttributeList });
              }}
              isBuyable={isBuyable}
              isOutSide={isOutSide}
            />

            <div className="userOptions">
              {skuDetail.useSkuList ? (
                <div
                  className="optionRow"
                  onClick={() => {
                    updateVisible('BuyPopup', true);
                  }}
                >
                  <span>规格</span>
                  <div className="optionVal">
                    共<span className="attr-count">{skuDetail.skuCount ?? 0}</span>种
                  </div>
                  <span className="attr-tip">选择规格</span>
                  <ArrowIcon className="arrow" />
                </div>
              ) : (
                <div
                  className="optionRow"
                  onClick={() => {
                    updateVisible('BuyPopup', true);
                  }}
                >
                  <span>已选</span>
                  <div className="optionVal">{choosenTxt}</div>
                  <ArrowIcon className="arrow" />
                </div>
              )}
              {!isOutSide && skuDetail.upstreamSupplierName && (
                <div className="optionRow">
                  <span>配送商</span>
                  <div className="optionVal">{skuDetail.upstreamSupplierName}</div>
                </div>
              )}
              <div
                className="optionRow"
                onClick={() => {
                  updateVisible('AreaPicker', true);
                }}
              >
                <span>送至</span>
                <div className="optionVal">
                  {selectAreas?.map((item: any) => item?.name).join(' ')}
                </div>
                <ArrowIcon className="arrow" />
              </div>

              {skuDetail.serviceProductTag?.length > 0 && (
                <div className="optionRow">
                  <span>服务</span>
                  <div className="optionVal">
                    {skuDetail.serviceProductTag?.map((v, i) => (
                      <div key={i} className="span-tag">
                        {v.tagName}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {selectTradeAgreement?.discountByMethodList &&
              selectTradeAgreement.discountByMethodList.length ? (
                <div className="accountPeriodWrp">
                  <AccountPeriodPicker
                    labelName="交易方式"
                    supplierSysNo={shopInfo.supplierSysNo}
                    discountByMethodList={selectTradeAgreement?.discountByMethodList || []}
                    billingPeriodOtherDays={selectTradeAgreement?.billingPeriodOtherDays}
                    onConfirm={(data: DiscountByMethodInfo) => {
                      setSelectAccountPeriod(data);
                    }}
                  />
                </div>
              ) : null}
            </div>
            <div ref={rateRef} className="rate-wrap">
              {canView ? (
                <div
                  className="optionRow"
                  onClick={() =>
                    router.push(
                      `/evaluation/list?supplierSysNo=${shopInfo.supplierSysNo}&shopScore=${shopInfo.score}`,
                    )
                  }
                >
                  <span>评价信息</span>
                  <div className="optionVal">共{rateTotal ?? 0}条</div>
                  <span className="attr-tip">查看全部</span>
                  <ArrowIcon className="arrow" />
                </div>
              ) : (
                <div className="optionRow" onClick={null}>
                  <span>评价信息</span>
                  <div className="optionVal">登录后查看信息</div>
                  <span className="attr-tip">
                    <a href={`/sso/login?return_url=${returnUrl}&role=purcharser`} target="_parent">
                      去登录
                    </a>
                  </span>
                  <ArrowIcon className="arrow" />
                </div>
              )}
            </div>
            {site?.mall?.enableSelfSiteMode === SITE_MODE.SHOP && (
              <ProductDetailShopSection
                shopName={shopInfo.name}
                shopSysNo={shopInfo.sysNo}
                score={shopInfo.score}
              />
            )}
            {skuDetail.detailContentOfHtml ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: skuDetail.detailContentOfHtml,
                }}
                className="content-html"
                ref={contentRef}
              />
            ) : (
              <ProductDetailAttachment attachmentList={skuDetail.attachmentList} ref={contentRef} />
            )}
            <ProductDetailRecommend
              ref={recommendRef}
              recommendSpuList={(skuDetail.recommendSpuDTO as any)?.recommendSpuList || []}
            />
          </div>
        </div>
        {skuDetail.useSkuList ? (
          <ProductDetailAddToSkuList
            source={source}
            skuList={skuList}
            showUsePart={showUsePart}
            selectTradeAgreement={selectTradeAgreement}
            shopInfo={shopInfo}
            skuDetail={skuDetail}
            selectAccountPeriod={selectAccountPeriod}
            selectStation={selectStation}
            station={station}
            // disabled={!isBuyable}
            disabled={cantBuyable}
            tradeAgreementArr={tradeAgreementEntityList || []}
            // btnTxt={ProductBuyStatus[productStatus]}
            btnTxt={ProductCantBuyTips[productCantBuyStatus]}
            setSelectStation={setSelectStation}
            setSkuList={setSkuList}
          />
        ) : (
          <ProductDetailAddToCartBar
            ref={playTargetRef}
            // disabled={!isBuyable}
            disabled={cantBuyable}
            onClickAdd={() => {
              setBuyType('AddToCart');
              updateVisible('BuyPopup', true);
            }}
            tradeAgreementArr={tradeAgreementEntityList || []}
            onClickBuy={() => {
              setBuyType('BuyNow');
              updateVisible('BuyPopup', true);
            }}
            // btnTxt={ProductBuyStatus[productStatus]}
            btnTxt={ProductCantBuyTips[productCantBuyStatus]}
            onClickShop={toShop}
          />
        )}
        <ProductDetailMmuPopup
          visible={visibles.BuyPopup}
          productStatus={productStatus}
          setShowUsePart={setShowUsePart}
          showUsePart={showUsePart}
          source={source}
          skuList={skuList}
          selectTradeAgreement={selectTradeAgreement}
          shopInfo={shopInfo}
          skuDetail={skuDetail}
          mmuAttributeTagList={skuDetail.mmuAttributeTagList}
          mmuAttributeList={mmuAttributeList}
          mmuAttributeClassifiers={mmuAttributeClassifiers}
          selectAccountPeriod={selectAccountPeriod}
          selectStation={selectStation}
          station={station}
          setSelectStation={setSelectStation}
          setSkuList={setSkuList}
          setStation={setStation}
          setMmuAttributeList={setMmuAttributeList}
          setMmuAttributeClassifiers={setMmuAttributeClassifiers}
          onClose={() => {
            updateVisible('BuyPopup', false);
          }}
          onChangeMmu={handleChangeMmu}
          onChangeSku={handleChangeSku}
          ref={mmuPopupRef}
          isBuyable={isBuyable}
          isOutSide={isOutSide}
        >
          {skuDetail.useSkuList ? null : (
            <div className="cartBtn">
              {isBuyable ? (
                <Button text="确定" type="primary" onClick={onPupupSubmit} />
              ) : (
                <Button
                  text={ProductBuyStatus[productStatus]}
                  type="primary"
                  className="noSaleBtn"
                  disabled
                />
              )}
            </div>
          )}
        </ProductDetailMmuPopup>
        <AreaPickerWithLevel
          areaLevel={3}
          visible={visibles.AreaPicker}
          skuSysNo={skuDetail?.sysNo}
          agreementSysNo={selectTradeAgreement?.parentSysNo}
          onChange={(val) => {
            setSelectAreas(val);
            updateVisible('AreaPicker', false);
          }}
          onInit={(val) => {
            setSelectAreas(val);
            updateVisible('AreaPicker', false);
          }}
          onClose={() => updateVisible('AreaPicker', false)}
        />
      </main>
      <style jsx>{`
        .page {
          height: 100vh;
          box-sizing: border-box;
          max-height: 100vh;
          overflow: auto;
          display: flex;
          flex-direction: column;
        }

        .nav {
          z-index: 100;
          display: flex;
        }

        .navTabs {
          display: inline-flex;
          justify-content: center;
          height: 44px;
          line-height: 44px;
          text-align: center;
          font-size: 18px;
          color: #333333;
          margin: 0 auto;
        }

        .navTab {
          margin-right: 24px;
          font-size: 14px;
          color: #666666;
          letter-spacing: 0;
          text-align: center;
          line-height: 44px;
        }

        .navTab:last-child {
          margin-right: 0;
        }

        .navTab.active {
          font-weight: bold;
          font-size: 15px;
          color: #2e2d37;
          letter-spacing: 0;
          position: relative;
          margin-top: -1px;
        }
        .navTab.active::after {
          content: "";
          background: var(--primaryColor);
          width: 15px;
          height: 2px;
          position: absolute;
          bottom: 9px;
          left: 7px;
        }

        .shareIcon {
          width: 18px;
          height: 17px;
        }

        .pageContent {
          height: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: stretch;
          flex-direction: column;
        }

        .main {
          flex: 1;
          flex-basis: calc(100vh - 100px);
          overflow: auto;
          background: #f5f5f5;
          padding-bottom: 56px;
        }

        .userOptions {
          background-color: #fff;
          margin-bottom: 10px;
        }

        .optionRow {
          height: 55px;
          display: flex;
          margin: 0 16px;
          line-height: 55px;
          align-items: center;
          justify-content: flex-start;
          position: relative;
        }

        .optionRow:not(:last-child)::after {
          content: "";
          border-bottom: 1px solid #dedede;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          transform: scaleY(0.5);
        }

        .optionRow span {
          font-size: 14px;
          color: #333333;
          letter-spacing: 0;
          line-height: 16px;
          font-weight: bolder;
          margin-right: 26px;
          flex-shrink: 0;
        }

        .optionVal {
          font-size: 14px;
          color: #666666;
          text-align: justify;
          line-height: 1.25;
          flex-grow: 1;
          padding-right: 10px;
          display: -webkit-box;
          overflow: hidden;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }

        .optionRow :global(.arrow) {
          height: 12px;
          width: 12px;
        }

        .optionRow :global(.arrow path) {
          fill: #999;
        }

        .accountPeriodWrp :global(.accountPeriod) {
          padding-right: 16px;
        }

        .accountPeriodWrp :global(.accountPeriod::before) {
          display: none;
        }

        .accountPeriodWrp :global(.periodLabel) {
          font-size: 14px;
          color: #333333;
          letter-spacing: 0;
          line-height: 16px;
          font-weight: bolder;
          margin-right: 26px;
          flex-shrink: 0;
        }

        .accountPeriodWrp :global(.periodVal) {
          flex-grow: 1;
        }

        .accountPeriodWrp :global(svg path) {
          fill: #999;
        }

        .optionVal .attr-count {
          font-size: 14px;
          color: #ea5604;
          margin-right: 0;
        }

        .userOptions .attr-tip {
          font-size: 14px;
          color: #bbbbbb;
          font-weight: normal;
          margin-right: 10px;
        }

        .content-html :global(img) {
          max-width: 100%;
        }

        .cartBtn {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: #fff;
          padding: 6px 15px 6px;
        }

        .noSaleBtn {
          opacity: 0.3;
          background-image: linear-gradient(270deg, #2531f4 0%, #1876ff 100%);
          box-shadow: 0 2px 12px 0 rgba(31, 82, 249, 0.25);
        }

        .rate-wrap {
          margin-bottom: 10px;
          background-color: #fff;
        }
        .span-tag {
          border: 1px solid #f5222d;
          border-radius: 1px;
          color: #f5222d;
          padding: 1px 2px;
          font-size: 12px;
          display: inline-block;
          margin-right: 4px;
          margin-bottom: 2px;
        }
        .tip-wrap {
          padding: 10px 14px 10px 16px;
          background: #ffeae0;
          font-size: 12px;
          color: #f5222d;
          line-height: 18px;
        }
      `}</style>
    </>
  );
}
